var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-manage-subscriptions-view',{attrs:{"list":_vm.list,"loading":_vm.loading,"canceling":_vm.canceling,"credit-card":_vm.creditCard,"enable-scroll":_vm.scroll},on:{"next":_vm.onNext,"cancel":_vm.onCancel}})}
var staticRenderFns = []

export { render, staticRenderFns }